export class InformacionIBR{

    public id:string='';
    public periodicidad:string='';
    public titulo:string='';
    public graficoIBR:any;
    public tablaIBR:any;

    public valorEfectiva:number=0;
    public valorNominal:number=0;

    public fecha:string='';
    public color:string='#FFFFFF';
    public unidad:string='';

}